
import {
	Math as THREEMath,
	Vector3,
	Color,
	TextureLoader,
	Mesh,
	MeshLambertMaterial,
	MeshBasicMaterial,
	MeshStandardMaterial,
	CubeGeometry,
	PointLightHelper,
	HemisphereLightHelper,
	SpotLightHelper,
	DirectionalLightHelper,
	AxesHelper,
	//ObjectLoader,
	Matrix3,
	Object3D,
	Box3,
	BoxHelper,
	VideoTexture,
	MeshPhongMaterial
} from '../../../../src/js/three.module.js';

import { ObjectLoader } from '../../../utils/object-loader.js';

import {
	rotateAroundWorldAxis,
	roundVector
} from '../../GameTools.js';

import { ObjectClickHandler }       from '../../../utils/object-click-handler.js';

import { CommentsHandler }      from '../../services/CommentsService.js';
import UserActionHistoryService from '../../services/UserActionHistoryService.js';
import { buildMaterialParameters, createDefaultMaterial, createMaterialByImageUrl, createTextureByImageUrl } from './utils.js';

import { createHemisphereGroundColor } from '../../../utils/colors.js';

import { getAdditionalObjectsService } from "./utils.js";

import { AdditionalObjectJSON } from './additional-object-json.js';
import { AdditionalObjectCube } from './additional-object-cube.js';

export class AdditionalObjectPlane extends AdditionalObjectCube {

    constructor( width, height, material, opts = {} ) {

        super( width, height, 0.01, material, opts );

        this.type = "plane";

        this.refreshHash();
    }

    setPlaceByIntersect( intersect ) {

        var point = AdditionalObjectJSON.prototype.setPlaceByIntersect.call( this, intersect );

        if (!point) return;

        gameService.shadowsNeedsUpdate = true;

        if (this.$lastNormal) {

            this.mesh.position.addScaledVector( this.$lastNormal, this.depth/2 );

            var targetPoint = this.mesh.position.clone().add( this.$lastNormal );
            this.mesh.lookAt( targetPoint );
        }
    }

    rotateOnPlane( plus ) {
        if (isNaN(plus = plus || 0) || typeof plus != "number") throw "Invalid argument!";

        if (plus == 0) return;

        this.mesh.rotateZ( plus );

        UserActionHistoryService.getInstance().do( "additionalObject.move", this, null, this.mesh.rotation.clone());
    }

    static fromOpts( opts ) {

        let material = { color: new Color( opts.color ) };
        let texture_img_uid = opts.texture_img_uid;  

        if (texture_img_uid) {

            material = createMaterialByImageUrl( "/i/"+ texture_img_uid +"?size=512x512!");
            
            //material.$img_uid = texture_img_uid;

        } else if (opts.texture_img_url) {

            material = createMaterialByImageUrl( opts.texture_img_url );

        }

        var obj = new AdditionalObjectPlane( opts.width, opts.height, material, { texture_img_uid });

        if (opts.uuid) obj.changeUuid( opts.uuid );

        return obj;
    }
    
    /**
     * Luodaan objekti tallennetun datapaketin perusteella
     */
    static loadSave( save ) {
        let additionalObjectsService = getAdditionalObjectsService();
        var obj = additionalObjectsService.generatePlane( save );

        return AdditionalObjectPlane.applySave( save, obj );
    }

    static applySave( save, obj ) {

        // Restore position and rotation if available
        if (Array.isArray(save.pos)) {
            obj.mesh.position.fromArray(save.pos);
        }
        if (Array.isArray(save.qua)) {
            obj.mesh.quaternion.fromArray(save.qua);
        }

        // Restore z-offset
        save.zof = parseFloat(save.zof);
        obj.z_offset = isNaN(save.zof) ? 0 : save.zof;

        // Restore title if present
        if (save.title) {
            obj.title = save.title;
        }

        // Initialize comments if present
        if (save.comments) {
            obj.comments.init(save.comments);
        }

        // Initialize object click actions
        if (save.clickActs) try {
            new ObjectClickHandler( save.clickActs, obj );
        } catch (error) {
            console.error( error );
        }

        return obj;
    }
}